/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import dayjs from 'dayjs';
import Badge from '@mui/material/Badge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { Modal, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import axios from 'lib/axios';
import EventByDateModal from './modals/EventByDateModal';
import MeetingsByDateModal from './modals/MeetingsByDateModal';
import { useSelector } from 'react-redux';

const Calander = ({ initialValue, upcoming, loading, updateHeighlitedDays, links, type, allowPast = false }) => {
    const pickersDayRef = useRef(null);
    const [isLoading, setIsLoading] = useState(loading);
    const [eventIsLoading, setEventIsLoading] = useState(false);
    const [highlightedDays, setHighlightedDays] = useState([]);
    const [formattedDate, setFormattedDate] = useState('');
    const [eventsByDate, setEventsByDate] = useState([]);
    const [meetingsByDate, setMeetingsByDate] = useState([]);

    const { formalEventType, meetingIsFormal, meetingIsRecorded } = useSelector((state) => state.frontMenu);
    // console.log(formalEventType);
    useEffect(() => {
        setHighlightedDays(() => [...upcoming]);
    }, [upcoming]);
    const handleMonthChange = (date) => {
        updateHeighlitedDays(setHighlightedDays, date.month(), setIsLoading, date.year());
    };
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setFormattedDate('');
        setEventsByDate([]);
        setMeetingsByDate([]);
        setEventIsLoading(false);
    };

    function ServerDay(props) {
        const { highlightedDays = [1, 2, 3], day, outsideCurrentMonth, ...other } = props;
        const index = highlightedDays.indexOf(props.day.date());
        const in_array = index >= 0;
        const isSelected = !props.outsideCurrentMonth && in_array;

        const formatDate = (date) => {
            return dayjs(date).format('YYYY-MM-DD');
        };

        return (
            <PickersDay
                {...other}
                ref={isSelected ? pickersDayRef : null}
                outsideCurrentMonth={outsideCurrentMonth}
                day={day}
                selected={isSelected}
                disabled={day <= new Date(new Date() - 24 * 60 * 60 * 1000) && !(allowPast && isSelected)}
                sx={{
                    borderRadius: '8px',
                    margin: '2px',
                    fontSize: '0.875rem',
                    fontWeight: isSelected ? 600 : 400,
                    backgroundColor: isSelected ? '#1976d2' : 'transparent',
                    color: isSelected ? '#ffffff' : 'inherit',
                    '&:hover': {
                        backgroundColor: isSelected ? '#1565c0' : '#f5f5f5',
                        transform: 'scale(1.05)',
                        transition: 'all 0.2s ease-in-out'
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#1976d2',
                        color: '#ffffff',
                        '&:hover': {
                            backgroundColor: '#1565c0'
                        }
                    },
                    '&.Mui-disabled': {
                        color: '#bdbdbd',
                        backgroundColor: 'transparent'
                    }
                }}
                onClick={() => {
                    if (isSelected) {
                        const nextDate = formatDate(day.toDate());
                        setEventsByDate([]);
                        setMeetingsByDate([]);
                        setFormattedDate(nextDate);
                        handleOpen();
                        handleSubmit(nextDate);
                    }
                }}
            />
        );
    }

    async function handleSubmit(targetDate) {
        if (!targetDate) return;
        try {
            setEventIsLoading(true);
            const res = await axios.post(type === 'events' ? '/events/event-by-date' : '/meetings/meeting-by-date', {
                is_formal: type === 'events' ? formalEventType : meetingIsFormal,
                is_recorded_meeting: type === 'events' ? false : meetingIsRecorded,
                target_date: targetDate
            });

            if (res.data.success) {
                if (type === 'events') {
                    setEventsByDate(res.data.events || []);
                } else {
                    setMeetingsByDate(res.data.meetings || []);
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setEventIsLoading(false);
        }
    }
    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                    sx={{
                        width: '100%',
                        '& .MuiDateCalendar-root': {
                            backgroundColor: 'transparent'
                        },
                        '& .MuiPickersCalendarHeader-root': {
                            marginBottom: '16px'
                        },
                        '& .MuiPickersCalendarHeader-label': {
                            fontSize: '1.125rem',
                            fontWeight: 600,
                            color: '#2c3e50'
                        },
                        '& .MuiPickersCalendarHeader-switchViewButton': {
                            color: '#1976d2'
                        },
                        '& .MuiDayCalendar-weekDayLabel': {
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            color: '#6c757d',
                            padding: '8px 0'
                        },
                        '& .MuiDayCalendar-monthContainer': {
                            backgroundColor: 'transparent'
                        }
                    }}
                    defaultValue={allowPast ? undefined : initialValue}
                    referenceDate={initialValue}
                    loading={isLoading}
                    onMonthChange={handleMonthChange}
                    renderLoading={() => <DayCalendarSkeleton />}
                    slots={{
                        day: ServerDay
                    }}
                    slotProps={{
                        day: {
                            highlightedDays
                        }
                    }}
                />
            </LocalizationProvider>
            {open && (
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '16px'
                    }}
                >
                    {type === 'events' ? (
                        <EventByDateModal
                            eventsByDate={eventsByDate}
                            formattedDate={formattedDate}
                            handleClose={handleClose}
                            eventIsLoading={eventIsLoading}
                        />
                    ) : (
                        <MeetingsByDateModal
                            handleClose={handleClose}
                            meetingsByDate={meetingsByDate}
                            formattedDate={formattedDate}
                            isLoading={eventIsLoading}
                        />
                    )}
                </Modal>
            )}
        </>
    );
};

export default Calander;
